import { s } from '../lib/style.js';

export function Partnership({ v }) {
  return (
    <section id="partnership" style={s("scroll-margin-top:80px;")}>
      <div style={s("max-width:1220px;margin:0 auto;padding:clamp(64px,9vw,120px) clamp(20px,4vw,28px);")}>
        <div style={s("text-align:center;max-width:700px;margin:0 auto;")}>
          <div
            style={s("display:inline-flex;align-items:center;margin-bottom:18px;padding:9px 20px;border-radius:999px;background:#FFFFFF;border:1px solid rgba(18,49,56,0.12);box-shadow:0 2px 10px rgba(18,49,56,0.06);font-family:var(--mono);font-weight:var(--mono-w);font-size:13.5px;letter-spacing:0.14em;text-transform:uppercase;color:var(--mint);")}
          >
            Design partnership
          </div>
          <h2
            style={s("font-family:'Sofia Pro',sans-serif;font-weight:500;font-size:clamp(32px,4.2vw,54px);line-height:1.05;letter-spacing:-0.03em;margin:0;color:var(--text);")}
          >
            Be on the
            {' '}
            <span style={s(v.kwLight)}>
              leading edge.
            </span>
          </h2>
          <p style={s("margin:20px 0 0;font-size:18px;line-height:1.65;color:var(--muted);")}>
            A bounded co-creation partnership: we discover what's most valuable to your team and build real agents, skills, and connectors against it — not open-ended consulting.
          </p>
        </div>
        <div
          style={s("position:relative;overflow:hidden;border-radius:28px;margin-top:clamp(46px,5vw,64px);background:linear-gradient(155deg,#0B2124 0%,#123138 52%,#1F5A54 128%);box-shadow:0 34px 80px rgba(18,49,56,0.26);")}
        >
          <div
            aria-hidden="true"
            style={s("position:absolute;inset:0;pointer-events:none;background:radial-gradient(90% 80% at 10% 0%,rgba(46,122,114,0.35),transparent 60%);")}
          />
          <div
            style={s("position:relative;display:grid;grid-template-columns:repeat(auto-fit,minmax(min(330px,100%),1fr));align-items:stretch;")}
          >
            <div
              style={s("display:flex;flex-direction:column;padding:clamp(30px,3.2vw,42px) clamp(26px,3vw,40px);")}
            >
              <div
                style={s("font-family:'Sofia Pro',sans-serif;font-weight:500;font-size:clamp(30px,3.2vw,42px);line-height:1.02;letter-spacing:-0.035em;color:#7ACEC0;")}
              >
                What you get
              </div>
              <div
                style={s("margin-top:14px;font-family:'Sofia Pro',sans-serif;font-weight:500;font-size:clamp(22px,2.2vw,28px);line-height:1.24;letter-spacing:-0.022em;color:#FFFFFF;max-width:400px;min-height:2.5em;text-wrap:pretty;")}
              >
                A platform bent toward your workflows.
              </div>
              <div style={s("display:flex;flex-direction:column;margin-top:28px;")}>
                <div
                  style={s("display:grid;grid-template-columns:auto 1fr;gap:20px;align-items:baseline;padding:22px 0;border-top:1px solid rgba(255,255,255,0.13);")}
                >
                  {' '}
                  <span
                    aria-hidden="true"
                    style={s("font-family:'Sofia Pro',sans-serif;font-weight:500;font-size:26px;line-height:1;letter-spacing:-0.03em;color:#7ACEC0;")}
                  >
                    01
                  </span>
                  {' '}
                  <div>
                    <div
                      style={s("font-family:'Sofia Pro',sans-serif;font-weight:500;font-size:20px;line-height:1.3;letter-spacing:-0.018em;color:#FFFFFF;")}
                    >
                      Early platform access
                    </div>
                    <div
                      style={s("margin-top:7px;font-size:16px;line-height:1.55;color:rgba(234,243,241,0.6);text-wrap:pretty;")}
                    >
                      Working software in your hands from week one — not a waitlist seat.
                    </div>
                  </div>
                </div>
                <div
                  style={s("display:grid;grid-template-columns:auto 1fr;gap:20px;align-items:baseline;padding:22px 0;border-top:1px solid rgba(255,255,255,0.13);")}
                >
                  {' '}
                  <span
                    aria-hidden="true"
                    style={s("font-family:'Sofia Pro',sans-serif;font-weight:500;font-size:26px;line-height:1;letter-spacing:-0.03em;color:#7ACEC0;")}
                  >
                    02
                  </span>
                  {' '}
                  <div>
                    <div
                      style={s("font-family:'Sofia Pro',sans-serif;font-weight:500;font-size:20px;line-height:1.3;letter-spacing:-0.018em;color:#FFFFFF;")}
                    >
                      Direct influence over the roadmap
                    </div>
                    <div
                      style={s("margin-top:7px;font-size:16px;line-height:1.55;color:rgba(234,243,241,0.6);text-wrap:pretty;")}
                    >
                      What your team needs most becomes what we build next, in weeks rather than release cycles.
                    </div>
                  </div>
                </div>
                <div
                  style={s("display:grid;grid-template-columns:auto 1fr;gap:20px;align-items:baseline;padding:22px 0;border-top:1px solid rgba(255,255,255,0.13);")}
                >
                  {' '}
                  <span
                    aria-hidden="true"
                    style={s("font-family:'Sofia Pro',sans-serif;font-weight:500;font-size:26px;line-height:1;letter-spacing:-0.03em;color:#7ACEC0;")}
                  >
                    03
                  </span>
                  {' '}
                  <div>
                    <div
                      style={s("font-family:'Sofia Pro',sans-serif;font-weight:500;font-size:20px;line-height:1.3;letter-spacing:-0.018em;color:#FFFFFF;")}
                    >
                      Agents built on your real data
                    </div>
                    <div
                      style={s("margin-top:7px;font-size:16px;line-height:1.55;color:rgba(234,243,241,0.6);text-wrap:pretty;")}
                    >
                      Trained against your categories and your questions, not a demo set.
                    </div>
                  </div>
                </div>
              </div>
              {' '}
              <a
                className="hv-15"
                href="#waitlist"
                style={s("align-self:flex-start;display:inline-flex;align-items:center;gap:10px;margin-top:auto;padding:15px 28px;border-radius:999px;background:#7ACEC0;color:#0B2124;text-decoration:none;font-size:16px;font-weight:500;letter-spacing:-0.01em;transition:transform .3s ease,box-shadow .3s ease;")}
              >
                {v.ctaLabel}
                {' '}
                <span>
                  →
                </span>
              </a>
              {' '}
            </div>
            <div
              style={s("display:flex;flex-direction:column;padding:clamp(30px,3.2vw,42px) clamp(26px,3vw,40px);background:#FFFFFF;")}
            >
              <div
                style={s("font-family:'Sofia Pro',sans-serif;font-weight:500;font-size:clamp(30px,3.2vw,42px);line-height:1.02;letter-spacing:-0.035em;color:var(--mint);")}
              >
                What we ask
              </div>
              <div
                style={s("margin-top:14px;font-family:'Sofia Pro',sans-serif;font-weight:500;font-size:clamp(22px,2.2vw,28px);line-height:1.24;letter-spacing:-0.022em;color:var(--text);max-width:400px;min-height:2.5em;text-wrap:pretty;")}
              >
                Real inputs, and time
                <br />
                in the room.
              </div>
              <div style={s("display:flex;flex-direction:column;margin-top:28px;")}>
                <div
                  style={s("display:grid;grid-template-columns:auto 1fr;gap:20px;align-items:baseline;padding:22px 0;border-top:1px solid var(--line);")}
                >
                  {' '}
                  <span
                    aria-hidden="true"
                    style={s("font-family:'Sofia Pro',sans-serif;font-weight:500;font-size:26px;line-height:1;letter-spacing:-0.03em;color:rgba(18,49,56,0.22);")}
                  >
                    01
                  </span>
                  {' '}
                  <div>
                    <div
                      style={s("font-family:'Sofia Pro',sans-serif;font-weight:500;font-size:20px;line-height:1.3;letter-spacing:-0.018em;color:var(--text);")}
                    >
                      Your real data
                    </div>
                    <div
                      style={s("margin-top:7px;font-size:16px;line-height:1.55;color:var(--muted);text-wrap:pretty;")}
                    >
                      Under appropriate agreements, with governance reviewed up front.
                    </div>
                  </div>
                </div>
                <div
                  style={s("display:grid;grid-template-columns:auto 1fr;gap:20px;align-items:baseline;padding:22px 0;border-top:1px solid var(--line);")}
                >
                  {' '}
                  <span
                    aria-hidden="true"
                    style={s("font-family:'Sofia Pro',sans-serif;font-weight:500;font-size:26px;line-height:1;letter-spacing:-0.03em;color:rgba(18,49,56,0.22);")}
                  >
                    02
                  </span>
                  {' '}
                  <div>
                    <div
                      style={s("font-family:'Sofia Pro',sans-serif;font-weight:500;font-size:20px;line-height:1.3;letter-spacing:-0.018em;color:var(--text);")}
                    >
                      Your team's time
                    </div>
                    <div
                      style={s("margin-top:7px;font-size:16px;line-height:1.55;color:var(--muted);text-wrap:pretty;")}
                    >
                      A few hours a month, and candid feedback when something misses.
                    </div>
                  </div>
                </div>
                <div
                  style={s("display:grid;grid-template-columns:auto 1fr;gap:20px;align-items:baseline;padding:22px 0;border-top:1px solid var(--line);")}
                >
                  {' '}
                  <span
                    aria-hidden="true"
                    style={s("font-family:'Sofia Pro',sans-serif;font-weight:500;font-size:26px;line-height:1;letter-spacing:-0.03em;color:rgba(18,49,56,0.22);")}
                  >
                    03
                  </span>
                  {' '}
                  <div>
                    <div
                      style={s("font-family:'Sofia Pro',sans-serif;font-weight:500;font-size:20px;line-height:1.3;letter-spacing:-0.018em;color:var(--text);")}
                    >
                      A willingness to iterate
                    </div>
                    <div
                      style={s("margin-top:7px;font-size:16px;line-height:1.55;color:var(--muted);text-wrap:pretty;")}
                    >
                      We ship early and adjust together — partnership, not procurement.
                    </div>
                  </div>
                </div>
              </div>
              <p
                style={s("margin:auto 0 0;padding-top:26px;font-size:15.5px;line-height:1.6;color:var(--muted);max-width:400px;text-wrap:pretty;")}
              >
                The teams that move now shape the category — early partners bend the roadmap toward the workflows they bring to the table.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
